import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  type?: string;
  name?: string;
  image?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title = "Professor X AI – AI Tutor, Visual Learning & Step-by-Step Explanations",
  description = "Professor X AI is an intelligent multilingual AI tutor that turns questions, concepts, syllabus and study material into step-by-step visual explanations, learning videos and structured study notes.",
  canonical = "https://professorxai.info/",
  type = 'website',
  name = 'Professor X AI',
  image = 'https://professorxai.info/profxlogo.png'
}) => {
  return (
    <Helmet>
      {/* Basic Standard HTML Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Facebook Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={name} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={image} />

      {/* Twitter Cards */}
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

